import { AlertTriangle, RefreshCw } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function ErrorState({
  title,
  message,
  onRetry,
}: {
  title?: string
  message?: string
  onRetry?: () => void
}) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-2xl border border-destructive/20 bg-destructive/5 px-8 py-16">
      <div className="flex size-14 items-center justify-center rounded-full bg-destructive/10">
        <AlertTriangle size={24} className="text-destructive" />
      </div>
      <div className="text-center">
        <h3 className="text-xl font-bold text-foreground">
          {title ?? t('common.errorState.title')}
        </h3>
        <p className="mt-1 text-muted-foreground">{message ?? t('common.errorState.message')}</p>
      </div>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-2 flex items-center gap-2 rounded-full bg-secondary px-6 py-2.5 font-bold text-white hover:opacity-90"
        >
          <RefreshCw size={16} />
          {t('common.errorState.retry')}
        </button>
      )}
    </div>
  )
}
